module.exports = __webpack_public_path__ + "img/start-ups-green.bdcd6482.svg";